<template>
  <v-app>
    <div v-if="showIntroPage()" class="intro">
      <!-- <img src="./assets/logo.png" />
            <h1 id="rcorners-top">Welcome to NDLM Portal</h1>
            <v-btn @click="proceed" :to="{path: '/signin'}" round color="primary">Get Started</v-btn> -->
      <img src="./assets/nirmaan_trans_logo.png" width="200" />
      <h1>Welcome to NDLM Portal</h1>
      <v-btn
        round
        dark
        large
        color="primary"
        @click="proceed"
        :to="{ path: '/signin' }"
      >
        Get Started
      </v-btn>
    </div>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  created() {
    //Get login status from store
    var login = this.$store.getters.get_login;
    //Redirect users to signin page if the user explicitly entered paths in
    //browser other than root and the user is not logged in
    if (this.onmain && !login && this.$route.path != "/") {
      this.onmain = false;
      //TODO ambiguity in using this._home or this._home() to access store's mutation methods. Using direct store exposed methods instead of using helper methods
      this.$store.commit("_home");
      this.$router.push({ path: "/signin" });
    } else if (this.onmain && login) {
      //Direct users to dashboard if the user is logged in
      this.onmain = false;
      this.$router.push({ path: "/main" });
    } else {
      console.log("In created() of index view!");
      this.onmain = this.$store.getters.get_home;
    }
  },
  data() {
    return {
      onmain: true //This variable is used to toggle landing page display
    };
  },
  methods: {
    proceed: function() {
      this.onmain = false;
      this.$store.commit("_home");
    },
    showIntroPage() {
      if (this.onmain && !this.$store.getters.get_login) return true;
      else return false;
    }
  },
  ...mapGetters(["get_home"]),
  ...mapMutations([
    // map `this._login()` to `this.$store.commit('_login')`
    "_home"
  ])
};
</script>

<style scoped>
.intro {
  margin: 48px 0 24px 32px;
  text-align: center;
}
.intro h1 {
  text-align: center;
  color: #8e24aa;
  font: 500 52px/60px sans-serif;
  margin-bottom: 32px;
  margin-top: 32px;
}
.rcorners {
  border-radius: 8px;
  background: #039be5;
  padding: 20px 52px;
  width: auto;
  line-height: 16px;
  letter-spacing: 0.21px;
  text-decoration: none;
  color: #039be5;
  font-size: 20px;
  display: inline-block;
  font-family: sans-serif, Arial, Helvetica;
  border: none;
  outline: none;
}
</style>
